import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=064f9bca&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
import style0 from "./Contact.vue?vue&type=style&index=0&id=064f9bca&prod&lang=scss&scoped=true"
import style1 from "./Contact.vue?vue&type=style&index=1&id=064f9bca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064f9bca",
  null
  
)

export default component.exports